import { render, staticRenderFns } from "./StudentListI.vue?vue&type=template&id=b73a0ad6&"
import script from "./StudentListI.vue?vue&type=script&lang=js&"
export * from "./StudentListI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports